var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 32,
    fill: "none",
    viewBox: "0 0 50 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#959595",
    fillRule: "evenodd",
    d: "M36.25 32h-26.2c-13.337 0-13.431-20.702-.094-20.828-2.183-8.27 9.56-13.45 14.472-6.703C33.768-5.058 50 1.606 50 15.423 50 22.41 43.562 32 36.25 32zm-15.118-7.706L25 20.317l3.868 3.977 2.617-2.692-3.867-3.978 3.867-3.977-2.617-2.693L25 14.932l-3.868-3.978-2.618 2.693 3.867 3.977-3.867 3.978 2.618 2.692z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.78d6a8f9b4ebf663dd6d8d198325eb9c.svg";
export { ForwardRef as ReactComponent };